import React, { useState, useEffect } from "react";
import { Flex, Icon, Link, Badge, Box, VStack, Heading, Text, useColorModeValue, useBreakpointValue, SimpleGrid, HStack,
     Table, Thead, Tbody, Tr, Th, Td, Button
 } from "@chakra-ui/react";
import axios from "axios";
import { Batch, Tutor, ActualClassDetails, Lesson } from '../Common/types';
import { FaUser, FaClock, FaMapMarkerAlt, FaVideo, FaBook } from "react-icons/fa";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";
import { useTenant } from "../Routers/TenantContextProvider";

const TutorUpcomingClasses = () => {
  const navigate = useNavigate();
  const [upcomingClasses, setUpcomingClasses] = useState<ActualClassDetails[]>([]);
  const [currentTutor, SetCurrentTutor] = useState<Tutor>();
  const actualclassdetailsCardBg = useColorModeValue("blue.100", "blue.700");
   const actualclassdetailsCardBg1 = useColorModeValue("blue.50", "blue.600");
  const textColor = useColorModeValue("blue.800", "blue.50");
  const bannerColor = useColorModeValue("yellow.100", "yellow.700");
    const headlineColor = useColorModeValue("teal.600", "teal.100");

  const { tenant, loading, error } = useTenant();

const getDuration = (start: string | Date, end: string | Date) => {
  const diffMs =
    parseUtc(end).getTime() - parseUtc(start).getTime();
  return `${Math.round(diffMs / 60_000)} mins`;
};


  const showBanner = useBreakpointValue({ base: false, md: true }); // Hide footer on smaller screens
  

  const handleLessonSummary = (selectedClass: ActualClassDetails) => {
    if (tenant)
    {
      navigate(`/platform/${tenant.tenant_slug}/app/tutor-upcoming-classes/lesson-summary/${selectedClass.planned_class_id}`, {
      state: { selectedClass }, // Pass the entire class object
    });
    }

  };


  const fetchUpcomingClasses = async () => {
    if (!currentTutor) return;

    try {
      const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
      const response = await axios.get(`${apiurl}/tutors/${currentTutor.tutor_id}/upcoming-class-details`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setUpcomingClasses(response.data);
      console.log("Upcoming Classes Data",response.data);
    } catch (error) {
      console.error("Failed to load enrolled actualclassdetails", error);
    }
  };

  useEffect(() => {
    const fetchCurrentTutor = async () => {
      try {
        const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
        const response = await axios.get(`${apiurl}/tutor`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        SetCurrentTutor(response.data);
      } catch (error) {
        console.error("Error fetching Tutor Info:", error);
      }
    };
    fetchCurrentTutor();
  }, []);

  useEffect(() => {
    if (currentTutor) {
        fetchUpcomingClasses();
    }
  }, [currentTutor]);

  return (

    <Box >
      {showBanner && (
    <Box bgColor={bannerColor} p={4} height={"70px"}>
      <HStack>
        <Heading   size={"sm"}>Hello  {currentTutor?.given_name} ! </Heading>
        <Text  fontWeight={"normal"} fontSize={"md"}>Checkout Upcoming Classes for Accessing Lesson Summary, Content and Launching Class.</Text>      
        </HStack>
    </Box>
          )}
          {!showBanner && (
          <Box p={4} bgColor={bannerColor} height={"50px"}>
            <VStack>
              <Text  fontWeight={"semibold"} fontSize={"md"}>My Upcoming Classes</Text>      
              </VStack>
          </Box>
          )}
    <Box as="main" mx="auto" maxWidth="1200px" p={4} color={textColor}>

    <SimpleGrid columns={{ base: 1, sm: 1, md: 3 }} spacing={6} mt={10}>
      {upcomingClasses.map((upcomingClass) => {
       // const startTimeFormatted = format(new Date(upcomingClass.start_time), "PPpp");
       const startTimeFormatted = fmtLocal(upcomingClass.start_time, {
          weekday: "short",
          day:     "numeric",
          month:   "short",
          hour:    "numeric",
          minute:  "2-digit",
          hour12:  true,
        });

        const isClassLive =
          Date.now() >= parseUtc(upcomingClass.start_time).getTime();
        // const endTimeFormatted = format(new Date(upcomingClass.end_time), "PPpp");
        // const isClassLive = new Date() >= new Date(upcomingClass.start_time);

        return (
          <Box
            key={upcomingClass.id}
            p={6}
            bg={actualclassdetailsCardBg}
            borderRadius="lg"
            boxShadow="xl"
            borderWidth="1px"
            borderColor="gray.200"
            transition="0.3s"
            _hover={{ transform: "translateY(-4px)", boxShadow: "2xl" }}
            
          >
            {/* Course Title */}
            <Heading size="md" mb={2} color={ headlineColor}>
            {upcomingClass.batch_title}
            </Heading>

            {/* Planned Class Details */}
            <Box mt={3} p={3} bg={actualclassdetailsCardBg1} borderRadius="md">
              <Heading size="sm" mb={1} colorScheme="purple">
                Class # : {upcomingClass.sequence_number}
              </Heading>
              <Text fontSize="sm">
                <strong>Title:</strong> {upcomingClass.title}
              </Text>
              <Text fontSize="sm">
                <strong>Description:</strong> {upcomingClass.description || "No description provided"}
              </Text>
            </Box>

    

            {/* Tutor Name */}
            <Flex mt={3} align="center" gap={2} mb={2}>
              <Icon as={FaUser} color="blue.500" />
              <Text fontSize="sm">
                <strong>Tutor:</strong> {upcomingClass.tutor_name || "Not Assigned"}
              </Text>
            </Flex>

            {/* Course Title */}
            <Flex align="center" gap={2} mb={2}>
              <Icon as={FaMapMarkerAlt} color="red.500" />
              <Text fontSize="sm">
                <strong>Course:</strong> {upcomingClass.course_title || "N/A"}
              </Text>
            </Flex>

            {/* Class Schedule */}
            <Flex align="center" gap={2} mb={2}>
              <Icon as={FaClock} color="green.500" />
              <Text fontSize="sm">
                <strong>Start:</strong> {startTimeFormatted}
              </Text>
            </Flex>

            <Flex align="center" gap={2} mb={2}>
              <Icon as={FaClock} color="orange.500" />
              <Text fontSize="sm">
                <strong>Duration:</strong> {getDuration(upcomingClass.start_time, upcomingClass.end_time)}
              </Text>
            </Flex>

            {/* Action Buttons */}
            <Flex mt={4} align="center">
            <Button colorScheme="blue" onClick={() => handleLessonSummary(upcomingClass)}>
              View Lessons
            </Button>
            </Flex>
          </Box>
        );
      })}
    </SimpleGrid>

    </Box>
    </Box>
  );
};

export default TutorUpcomingClasses;
